(function($) {
  $(document).ready(function() {
    profet = {
      elements: {},
      variables: {},
      init: function() {
        profet.handleResize();
        profet.handleScroll();
        profet.handleClicks();
        profet.handleTabLinks();
        profet.setupCarousels();
        profet.loadProductComparisonValues();
        profet.setWidowFix();
        profet.setupProductImageGallery();
        //profet.setBodyPadding();
      },
      setWidowFix: function() {
        /* Apply Widowfix, which prevents single words on new lines */
        /* https://github.com/matthewlein/jQuery-widowFix */
        var windowFixConfig = { letterLimit: 10 };
        $(".widowfix").widowFix(windowFixConfig);
        $(".profet-block-text-block")
          .find("p")
          .widowFix(windowFixConfig);
      },
      setBodyPadding: function() {
        headerMobile = $("#header-mobile");
        headerDesktop = $("#header-desktop");

        if (headerMobile.is(":visible")) {
          var paddingToSet = headerMobile.outerHeight();
          $("#main").css("paddingTop", paddingToSet);
        }

        if (headerDesktop.is(":visible")) {
          var paddingToSet = headerDesktop.outerHeight();
          $("#main").css("paddingTop", paddingToSet);
        }
      },
      handleResize: function() {
        $(window).on("resize", function() {});
      },
      handleScroll: function() {
        $(window).on("scroll", function(event) {
          profet.setDesktopMenuClass();
          profet.setMobileMenuClass();
          profet.handlePopupBannerDisplay();
        });
      },
      handleClicks: function() {
        /* Modal */
        $(".close-modal-btn").on("click", function() {
          profet.closeModal();
        });
        $(".profet-modal").on("click", function(event) {
          event.stopPropagation();
          profet.closeModal();
        });
        $(".profet-modal-inner").on("click", function(event) {
          event.stopPropagation();
        });

        /* Smooth scroll on anchors */
        $(document).on("click", 'a[href^="#"]:not([data-toggle="modal"])', function(event) {
          event.preventDefault();

          var element = $($(this).attr("href"));
          if (!element.length) {
            return;
          }

          $("html, body").animate({ scrollTop: $($.attr(this, "href")).offset().top - 100 }, 500);
        });

        $(".product-comparison-select-1").on("change", function() {
          profet.productComparisonDoAjaxRequest($(this), $(".product-comparison-container-1"), 1);
        });

        $(".product-comparison-select-2").on("change", function() {
          profet.productComparisonDoAjaxRequest($(this), $(".product-comparison-container-2"), 2);
        });

        $("[data-read-more-target]").on("click", function() {
          var target = $(this).data("read-more-target");
          var targetElement = $(target);
          targetElement.removeClass("show-blog-excerpt");
          $(this)
            .parents(".read-more-wrapper")
            .hide();
        });

        $("[data-profet-slidetoggle]").on("click", function(event) {
          event.preventDefault();
          var target = $(this).attr("data-profet-slidetoggle");
          var targetElement = $(target);
          targetElement.slideToggle();
        });

        $(".more-link").on("click", function() {});

        $(".profet-block-popup-banner-wrapper")
          .find(".close-btn")
          .on("click", function(event) {
            event.preventDefault();
            $(".profet-block-popup-banner-wrapper").addClass("popup-banner-closed");
            $(".profet-block-popup-banner-wrapper").removeClass("popup-banner-visible");
            profet.setCookie("popup-banner", "closed", 1);
          });

        $(".toggle-mobile-menu").on("click", function() {
          $("#header-mobile").toggleClass("toggled");

          if ($("#header-mobile").hasClass("scrolled")) {
            return;
          }

          $("#header-mobile").toggleClass("dark-temp");
        });

        $(".profet-information-tab-button").on("click", function(event) {
          event.preventDefault();
          var tabToShow = $($(this).attr("data-profet-show-tab"));
          $(".profet-information-tab-button").removeClass("active");
          $(this).addClass("active");

          $(".profet-information-tab-content").removeClass("active");
          tabToShow.addClass("active");

          if ($(window).width() < 768) {
            $("html, body")
              .stop()
              .animate(
                {
                  scrollTop: parseInt(tabToShow.offset().top - 100, 10),
                },
                700,
                "swing",
                function() {}
              );
          }
        });

        $("[data-slide-toggle-target]").on("click", function() {
          var target = $(this).data("slide-toggle-target");
          $(target).toggleClass("show-all-open");
          var oldText = $(this).html();
          var newText = $(this).data("toggle-text");
          $(this).html(newText);
          $(this).data("toggle-text", oldText);
        });
      },
      closeModal: function() {
        $(".profet-modal").fadeOut(250);
        profet.setCookie("modal", "closed", 1);
      },
      /* Generate a random string */
      generateRandomString: function() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 8; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
      },
      convertToSlug: function(text) {
        return text
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "");
      },
      getCookie: function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ") c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      },
      setCookie: function(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      },
      handleTabLinks: function() {
        // Get the hash from the URL
        var hash = window.location.hash;

        // If the hash contains the value of a tab, we want to show that tab
        if (hash) {
          var tabToShow = $(hash);
          if (tabToShow.length > 0) {
            $(".profet-information-tab-button").removeClass("active");
            $(".profet-information-tab-content").removeClass("active");

            var tabButton = $(".profet-information-tab-button[data-profet-show-tab='" + hash + "']");
            tabButton.addClass("active");

            tabToShow.addClass("active");

            if ($(window).width() < 1180) {
              $("html, body")
                .stop()
                .animate(
                  {
                    scrollTop: parseInt(tabToShow.offset().top - 100, 10),
                  },
                  700,
                  "swing",
                  function() {}
                );
            }
          }
        }
      },
      setupCarousels: function() {
        $(".products-carousel-mobile").slick({
          centerMode: true,
          dots: false,
          slidesToShow: 1,
          arrows: false,
          variableWidth: true,
        });

        $(".products-carousel-mobile").on("afterChange", function(event, slick, currentSlide) {
          var slideText = $(this)
            .find("[data-slick-index=" + currentSlide + "]")
            .find(".product-text-content")
            .html();
          var textContainer = $(this)
            .parent()
            .find(".products-carousel-mobile-text-container");
          textContainer.css("opacity", 0);
          textContainer.html(slideText);
          textContainer.animate({ opacity: 1 }, 500);
        });

        $(".products-carousel-desktop").slick({
          dots: false,
          slidesToShow: 3,
          arrows: true,
          prevArrow: '<a class="slick-prev"><img src="' + profetVars.imagesUrl + '/icon-chevron-left.png"></a>',
          nextArrow: '<a class="slick-next"><img src="' + profetVars.imagesUrl + '/icon-chevron-right.png"></a>',
        });

        $(".related-products-slider").slick({
          centerMode: true,
          dots: false,
          slidesToShow: 1,
          arrows: false,
          variableWidth: true,
        });

        $(".related-products-slider").on("afterChange", function(event, slick, currentSlide) {
          var slideText = $(".related-products-slider")
            .find("[data-slick-index=" + currentSlide + "]")
            .find(".profet-single-related-product-info")
            .html();
          $(".related-products-mobile-text-container").css("opacity", 0);
          $(".related-products-mobile-text-container").html(slideText);
          $(".related-products-mobile-text-container").animate({ opacity: 1 }, 500);
        });
      },
      setDesktopMenuClass: function() {
        if (!$("#header-desktop").is(":visible")) {
          return;
        }

        var scrollTop = $(window).scrollTop();
        var desktopMenuHeight = $("#header-desktop").outerHeight();
        if (scrollTop > desktopMenuHeight + 100) {
          $("#header-desktop").addClass("dark-temp");
        } else {
          $("#header-desktop").removeClass("dark-temp");
        }
      },
      setMobileMenuClass: function() {
        if (!$("#header-mobile").is(":visible")) {
          return;
        }

        if ($("#header-mobile").hasClass("toggled")) {
          return;
        }

        var scrollTop = $(window).scrollTop();
        var mobileMenuHeight = $("#header-mobile").outerHeight();
        if (scrollTop > mobileMenuHeight) {
          $("#header-mobile").addClass("dark-temp");
          $("#header-mobile").addClass("scrolled");
        } else {
          $("#header-mobile").removeClass("dark-temp");
          $("#header-mobile").removeClass("scrolled");
        }
      },
      handlePopupBannerDisplay: function() {
        if (!$(".profet-block-popup-banner-breakpoint").length > 0) {
          return;
        }

        var scrollPoint = $(window).scrollTop() + $(window).height();
        var breakpoint = $(".profet-block-popup-banner-breakpoint").offset().top;
        var wrapper = $(".profet-block-popup-banner-wrapper");
        if (scrollPoint > breakpoint && !wrapper.hasClass("popup-banner-closed")) {
          if (profet.getCookie("popup-banner") == "closed") {
            return;
          }
          wrapper.addClass("popup-banner-visible");
        }
      },
      loadProductComparisonValues: function() {
        if ($(".profet-block-product-comparison").length < 1) {
          return;
        }

        var select1 = $(".product-comparison-select-1");

        profet.productComparisonDoAjaxRequest(select1, $(".product-comparison-container-1"), 1);
      },
      productComparisonDoAjaxRequest: function(originElement, resultTarget, number) {
        comparisonTargetContainer = resultTarget;
        comparisonNumber = number;

        productId = originElement.val();

        $.ajax({
          url: "/wp-json/profet/getProductsComparisonData",
          data: {
            product_id: productId,
          },
          type: "GET",
          success: function(data) {
            comparisonTargetContainer.html(data.data.data);
            if (comparisonNumber === 1) {
              profet.productComparisonDoAjaxRequest(
                $(".product-comparison-select-2"),
                $(".product-comparison-container-2"),
                2
              );
            }
          },
          error: function(error) {
            console.error(error);
          },
        });
      },
      setupProductImageGallery: function() {
        $(".single-gallery-image-thumbnail-link").on("click", function(event) {
          event.preventDefault();
          var mainImage = $(".main-product-image-wrapper").find("img.main-image");
          if (!mainImage) {
            return;
          }
          var newSrc = $(this).attr("data-image-src");
          if (!newSrc) {
            return;
          }
          /* Reset the srcset for the image to make our image switching work */
          mainImage.attr("srcset", "");
          mainImage.attr("src", newSrc);

          /* Set the Featherlight lightbox url to the new image URL, so that the user can view the image in full screen */
          var lightboxToggle = $(".main-product-image-wrapper .fullscreen-link");
          if (lightboxToggle) {
            lightboxToggle.attr("data-featherlight", newSrc);
          }
        });
      },
    };

    profet.init();
  });
})(jQuery);
